export default {
    name: "page-not-found",
    data() {
        return {};
    },
};
